import NPECheck from './NPECheck';
import buildCarrierStartSmsUri from './buildCarrierStartSmsUri';

export function getErrorMessage(error) {
  if (!error) return null;

  let errorMsg = NPECheck(error, 'graphQLErrors/0/message', null);
  if (errorMsg) return errorMsg;

  errorMsg = NPECheck(error, 'networkError/result/errors/0/message', null);
  if (errorMsg) return errorMsg;
}

export function getJoiErrors(error) {
  if (!error) return null;
  const errorMsg = NPECheck(error, 'graphQLErrors/0/extensions/exception/invalidArgs', null);
  if (errorMsg) return errorMsg;
}

export function isCarrierStartRequired(error) {
  if (!error) return false;
  const code = NPECheck(error, 'graphQLErrors/0/extensions/code', null);
  return code === 'CARRIER_START_REQUIRED';
}

export function getCarrierStartOrganizationPhone(error) {
  if (!error) return null;
  return NPECheck(error, 'graphQLErrors/0/extensions/organizationPhoneNumber', null);
}

export function getCarrierStartSmsUri(error) {
  if (!error) return null;
  return NPECheck(error, 'graphQLErrors/0/extensions/carrierStartSmsUri', null);
}

export function handleSendPhoneCodeError(error, {
  setError,
  setCodeInputIsVisible,
  setCarrierStartPhone,
  setCarrierStartSmsUri,
  setShowCarrierStartInstructions,
}) {
  if (isCarrierStartRequired(error)) {
    if (setError) setError('');
    if (setCodeInputIsVisible) setCodeInputIsVisible(false);
    const phone = getCarrierStartOrganizationPhone(error);
    if (setCarrierStartPhone) {
      setCarrierStartPhone(phone);
    }
    if (setCarrierStartSmsUri) {
      setCarrierStartSmsUri(getCarrierStartSmsUri(error) || buildCarrierStartSmsUri(phone));
    }
    if (setShowCarrierStartInstructions) setShowCarrierStartInstructions(true);
    return;
  }
  if (setShowCarrierStartInstructions) setShowCarrierStartInstructions(false);
  if (setError) setError(getErrorMessage(error));
}
